const map = {
	"./1/bildspel_industri_och_slojdutstallning.json": 3387,
	"./1/ciceron_anna_olsson.json": 5505,
	"./1/ciceron_drottning_ingeborg.json": 211,
	"./1/ciceron_drottning_margareta.json": 1034,
	"./1/ciceron_lavesson_dominikanermunk.json": 6634,
	"./1/elever_och_larare_gosslaroverket_479_51037.json": 1534,
	"./1/manifest.json": 6127,
	"./1/smoking_youth_7465_2008_1.json": 9190,
	"./10/alva_asp_i_sang.json": 1131,
	"./10/bildspel_st_maria.json": 7850,
	"./10/brev_eldbegangelse_2657_2018.json": 9493,
	"./10/ciceron_alva_asp.json": 4843,
	"./10/ciceron_ron_clifford.json": 5813,
	"./10/manifest.json": 3481,
	"./11/bildspel_frohandel.json": 444,
	"./11/ciceron_curt_soren_samuelsson.json": 1192,
	"./11/hanna_fortmeijer_1955_2005.json": 8718,
	"./11/manifest.json": 4200,
	"./12/game1_book_spread.json": 7905,
	"./12/game1_drawer.json": 3833,
	"./12/game1_gisela_trapp.json": 3285,
	"./12/game1_oscar_trapp.json": 9254,
	"./12/game1_torsten_martensson.json": 3234,
	"./12/manifest.json": 4855,
	"./13/bildspel_hefoma_och_hogvaktens_konditori.json": 5731,
	"./13/bildspel_metoo_och_mandagsrorelsen.json": 3676,
	"./13/ciceron_bengta_jacobsdotter.json": 7117,
	"./13/ciceron_lykttandaren.json": 5366,
	"./13/hast_och_vagn_pa_stortorget_641_72019.json": 9073,
	"./13/manifest.json": 4334,
	"./14/bildspel_brottsmal_hilda_nilsson.json": 654,
	"./14/ciceron_ella_nordlund.json": 4391,
	"./14/ciceron_nils_glaermester.json": 2140,
	"./14/manifest.json": 8101,
	"./14/torghandel_66_241.json": 9273,
	"./14/utgravning_oversisktsbild_64_544.json": 7741,
	"./15/allerum_varg.json": 6244,
	"./15/manifest.json": 1220,
	"./2/bildspel_rostrattsinsamling_1914.json": 4699,
	"./2/ciceron_sara_thastrom.json": 2215,
	"./2/gamla_radhuset_30_36.json": 7254,
	"./2/kristina_borg_262_28.json": 4169,
	"./2/magnus_stenbock_tavla_800_2007.json": 124,
	"./2/manifest.json": 8528,
	"./3/angfarjans_restaurang_545520122.json": 8229,
	"./3/ciceron_elina_thelander.json": 5683,
	"./3/ciceron_joel_lonnqvist.json": 6835,
	"./3/ciceron_jytte_cohen.json": 6394,
	"./3/jytte_cohen_och_syskon_dig_2011_1247.json": 6436,
	"./3/manifest.json": 1825,
	"./4/ciceron_axel_jonason.json": 4778,
	"./4/ciceron_thor_forslund.json": 8134,
	"./4/manifest.json": 1746,
	"./5/bakgard_kvarteret_amerika_76_341.json": 7539,
	"./5/bildspel_hanna_christer_nilsson_brev.json": 9938,
	"./5/ciceron_hanna_christer_nilsson.json": 8344,
	"./5/ciceron_john_hansson.json": 7768,
	"./5/ciceron_nanny_palmkvist.json": 6506,
	"./5/ciceron_nelly_gunnarsson.json": 2103,
	"./5/folkets_hus_76_27_19_20.json": 3021,
	"./5/manifest.json": 3787,
	"./6/automaten.json": 988,
	"./6/bildspel_centralstationen.json": 8679,
	"./6/ciceron_fredrika_thysenius_hogstedt_hunter.json": 5292,
	"./6/ciceron_minna_hjertstrand.json": 9742,
	"./6/klassrum_appelgrenska_dig_2012_2263.json": 862,
	"./6/manifest.json": 2908,
	"./6/pridetag_dig_2016_125.json": 1705,
	"./6/tre_kvinnor_fattighuset_3742_2023.json": 2790,
	"./7/ciceron_bronsaldersflicka.json": 8505,
	"./7/ciceron_maria_persson.json": 8973,
	"./7/manifest.json": 1789,
	"./8/ciceron_arthur.json": 8095,
	"./8/ciceron_ingar.json": 3622,
	"./8/ciceron_signe.json": 5301,
	"./8/manifest.json": 3454,
	"./8/sockertoppstillverkning.json": 177,
	"./8/speceriaffar.json": 1978,
	"./9/ciceron_mikael_rudesjo.json": 6254,
	"./9/ciceron_tralflicka.json": 5451,
	"./9/flygfotografi_over_dalhem.json": 158,
	"./9/manifest.json": 7815,
	"./9/modell_av_hyreshus_dalhem_70_200902.json": 6129
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1822;